import { i18n } from "@/shared/i18n";

/**
 * UMA FRASE DO MOTOR DE FORMULÁRIOS, pedida de fora de um componente.
 *
 * ── POR QUE ISTO EXISTE ───────────────────────────────────────────────────
 *
 * Metade de `src/dynamic/` não é componente nenhum. `widgets/contract.ts` é um
 * mapa de validadores puros, `resolvers/list-view.ts` decide o que uma tabela
 * vazia diz, `autofill.ts` é uma lista de constantes. Nenhum tem `setup`, e
 * `useI18n` fora de um `setup` devolve a instância errada ou nada.
 *
 * A alternativa era passar um `t` por parâmetro. Seria mais puro e atravessaria
 * seis assinaturas — `validate(value, field, t)`, `emptyStateOf(entity, kind,
 * t)` — para o mesmo fim, e cada chamador teria de arranjar um `t` para
 * repassar. A LÍNGUA DO PAINEL é global de verdade: há uma, ela está em
 * `i18n.global.locale`, e fingir que é um argumento não a torna menos global.
 *
 * ── O PREÇO, DITO EM VOZ ALTA ─────────────────────────────────────────────
 *
 * Uma frase pedida assim NÃO é reativa. Um `computed` que a chame recalcula
 * quando a língua muda (porque `i18n.global.locale` é reativo e o `t` lê-o);
 * uma string guardada num `ref` no momento do erro fica na língua em que o erro
 * aconteceu, até o próximo erro. Para uma mensagem de validação isso é o
 * comportamento certo — ela nasce e morre num submit. Uma CONSTANTE de módulo
 * não pode ser escrita assim, e nenhuma é: os rótulos de `autofill.ts` chegam à
 * tela por `useStructureI18n().autofillOptions`, que os resolve por componente e
 * reage à troca de idioma; o que está no arquivo é só o texto de recurso.
 *
 * ── O `dynamicForm.` NO PREFIXO ───────────────────────────────────────────
 *
 * Posto aqui e não em cada chamada, para que nenhuma delas possa esquecê-lo e
 * ir buscar uma palavra da raiz partilhada com o nome parecido.
 */
export function say(key: string, values?: Record<string, unknown>): string {
	return values ? i18n.global.t(`dynamicForm.${key}`, values) : i18n.global.t(`dynamicForm.${key}`);
}
